import api from '../../api/leadRealAPI'
import router from '../../router'
import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    userData: null,
    progress: false,
    countries: null,
    invalidEmail: null,
    prefectures: null,
    plans: null
  },

  getters: {
    user: state => state.userData,
    countries: state => state.countries,
    invalidEmail: state => state.invalidEmail,
    prefectures: state => state.prefectures,
    plans: state => state.plans
  },

  mutations: {
    setUserData (state, user) {
      state.userData = user
    },
    setProgress (state, progress) {
      state.progress = progress
    },
    setCountries (state, countries) {
      state.countries = countries
    },
    setPrefectures (state, prefectures) {
      state.prefectures = prefectures
    },
    setInvalidEmail (state, invalidEmail) {
      state.invalidEmail = invalidEmail
    },
    setPlans (state, plans) {
      state.plans = plans
    }
  },

  actions: {
    addNewMember ({ commit }, data) {
      api
        .post('/admin/registeredMember', data)
        .then(response => {
          if (response === undefined) {
            commit('setInvalidEmail', 'このメールアドレスは使用できません。')
          }
          commit('setProgress', true)
          commit('setApiStatus', response.data.success, { root: true })
          setTimeout(() => commit('setApiStatus', null, { root: true }), 3000)
        }).catch(() => {
          commit('setInvalidEmail', 'このメールアドレスは使用できません。')
        })
    },
    prefectureCountry ({ commit }) {
      api
        .get('/admin/addressStateCountry')
        .then(response => {
          commit('setCountries', response.data.countries)
          commit('setPrefectures', response.data.prefectures)
        }).catch(() => {})
    },
    prefectureCountryClient ({ commit }) {
      api
        .get('/member/addressStateCountryClient')
        .then(response => {
          commit('setCountries', response.data.countries)
          commit('setPrefectures', response.data.prefectures)
        }).catch(() => {})
    },
    planClient ({ commit }) {
      api
        .get('/member/plans')
        .then(response => {
          commit('setPlans', response.data.data)
        }).catch(() => {})
    },
    addNewClient ({ commit }, data) {
      // Stripe決済後の戻り先の画面のURLを生成する
      const successRoute = router.resolve({ name: 'Client Entry Detail Thanks', params: { lang: router.currentRoute.params.lang } })
      data.success_url = location.origin + successRoute.href

      api
        .post('/member/memberAccountRegister', data)
        .then(response => {
          if (response.status === 200) {
            Vue.$cookies.remove('access_token')
            const checkoutUrl = response.data.data.checkout_url
            if (checkoutUrl == null) {
              // checkoutUrlがnullなら無料会員なので、会員登録の完了画面に飛ばす
              router.push({ name: 'Client Entry Detail Thanks', params: { lang: router.currentRoute.params.lang } })
            } else {
              // Stripeの決済ページにredirectする
              location.href = checkoutUrl
            }
          }
        }).catch(() => {})
    }
  }
}
